import { Link } from 'react-router-dom';

const BlockFillingHero = () => {
  return (
    <section className="relative bg-gradient-to-b from-slate-50 to-white py-20">
      <div className="absolute inset-0 bg-gradient-to-b from-black/5 via-transparent to-transparent"></div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
        <div className="text-center max-w-4xl mx-auto">
          <div className="inline-flex items-center gap-2 bg-amber-500 text-white px-4 py-2 rounded-full text-sm font-medium mb-6">
            <i className="ri-building-line"></i>
            Structural Excellence
          </div>
          <h1 className="text-5xl md:text-6xl font-bold text-slate-900 mb-6">
            Professional Block Filling Services
          </h1>
          <p className="text-xl text-slate-600 mb-8 leading-relaxed">
            Expert concrete block wall filling for residential and commercial projects. We provide structural reinforcement and quality assurance for all your masonry needs in Western North Carolina.
          </p>
          <div className="flex flex-wrap items-center justify-center gap-4">
            <Link
              to="/schedule"
              className="inline-flex items-center gap-2 bg-slate-900 text-white px-8 py-4 rounded-lg font-semibold hover:bg-slate-800 transition-colors whitespace-nowrap cursor-pointer"
            >
              Request a Quote
              <i className="ri-arrow-right-line"></i>
            </Link>
            <a
              href="tel:8282620091"
              className="inline-flex items-center gap-2 bg-white text-slate-900 px-8 py-4 rounded-lg font-semibold border-2 border-slate-900 hover:bg-slate-50 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-phone-line"></i>
              (828) 262-0091
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BlockFillingHero;